export const SHOPIFY_API_LIBRARY_VERSION = '12.0.0';
